export default {

	EMAIL_URL: 'https://asia-northeast1-cloud-accele-freight.cloudfunctions.net/send_email', // email cloud function

	TITLE: 'AcceleFreight',
	COOKIES_LOGIN_KEY: '____afulr',
	COOKIES_SESSION_KEY: '____afus',


	CONTACT_MAIL: 'calvin.wong@accelefreight.com',
	INFO_MAIL: 'info@accelefreight.com',


	SUPPORTED_CURRENCIES: ['MYR', 'USD'],


	// Response status
	// RESPONSE_STATUS_OK: 200,
	RESPONSE_STATUS_OK: 'OK',


	isObjectEmpty: function (object) {
		return Object.keys(object).length <= 0;
	},

	containsObject: function (obj, list) {
		var i;
		for (i = 0; i < list.length; i++) {
			if (list[i] === obj) {
				return true;
			}
		}

		return false;
	},

	getDate: function (offset) {
		var today = new Date();
		today.setDate(today.getDate() + offset);
		var dd = today.getDate();
		var mm = today.getMonth() + 1; //January is 0!

		var yyyy = today.getFullYear();
		if (dd < 10) {
			dd = '0' + dd;
		}
		if (mm < 10) {
			mm = '0' + mm;
		}
		var today = yyyy + '-' + mm + '-' + dd;

		return today;
	},

	getDateFromDateTimeString: function (dateTimeStr) {
		return dateTimeStr.substring(0, 10);
	},

	addDaysToDate: function (dateStr, days) {
		var date = new Date(dateStr);

		date.setDate(date.getDate() + days);

		var dd = date.getDate();
		var mm = date.getMonth() + 1; //January is 0!

		var yyyy = date.getFullYear();
		if (dd < 10) {
			dd = '0' + dd;
		}
		if (mm < 10) {
			mm = '0' + mm;
		}

		var returnStr = yyyy + '-' + mm + '-' + dd;

		return returnStr;
	},

	parseTime: function (timeStr) {
		if (timeStr == null) {
			return null;
		}

		var time = timeStr.match(/^\s*(\d\d?)(?::?(\d\d))?(?::(\d\d))?(?!\d)(\.\d+)?\s*(pm?|am?)?/i);
		if (time) {
			var localDate = false;
			var hour = parseInt(time[1]),
				pm = (time[5] || ' ')[0].toUpperCase();
			var min = time[2] ? parseInt(time[2]) : 0;
			//var sec = time[3] ? parseInt(time[3]) : 0;
			//var ms = (time[4] ? parseFloat(time[4]) * 1000 : 0);
			if ((pm !== ' ' && (hour == 0 || hour > 12)) || hour > 24 || min >= 60) return null;
			if (pm === 'A' && hour === 12) hour = 0;
			if (pm === 'P' && hour !== 12) hour += 12;
			if (hour === 24) hour = 0;
			var date = new Date(localDate !== undefined ? localDate.valueOf() : 0);
			var set = localDate !== undefined ? date.setHours : date.setUTCHours;
			set.call(date, hour, min);
			return date;
		}
		return null;
	},
};